import { createBreakpoints } from '@chakra-ui/theme-tools';

export default createBreakpoints({
  sm: '360px',
  md: '768px',
  lg: '1366px',
  xl: '1536px',
  '2xl': '1920px',
});
